import RafflesContent from "./RafflesContent";

export default RafflesContent;